export enum CustomEventType {
  IssueSnapshotClick = "issue-snapshot-click",
  PlacementLinkClick = "placement-link-click",
  IssueCreated = "issue-created",
  IssueDeleted = "issue-deleted",
  IssueModified = "issue-modified",
}
